import moment from 'moment'

import { buildUrl as buildAvatarUrl } from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { FormattedCostCenterEmployeeWithStructuredAssignment } from './types'

export const getColumns = () => {
  return [
    {
      sorting: 'fullName' as const,
      label: i18n.t('finance.cost_centers_list.headers.name'),
      render: (item: FormattedCostCenterEmployeeWithStructuredAssignment) => {
        if (item.isChild) {
          return {
            type: 'text' as const,
            value: {
              placeholder: i18n.t('finance.cost_centers_list.headers.job_catalog.not_applicable'),
            },
          }
        }

        return {
          type: 'person' as const,
          value: {
            firstName: item.firstName ?? '',
            lastName: item.lastName ?? '',
            src: buildAvatarUrl(item.avatar?.url),
            deactivated: !item.active,
          },
        }
      },
    },
    {
      label: i18n.t('finance.cost_centers_list.headers.legal_entity'),
      render: (item: FormattedCostCenterEmployeeWithStructuredAssignment) => {
        if (item.isChild) {
          return {
            type: 'text' as const,
            value: {
              placeholder: i18n.t('finance.cost_centers_list.headers.job_catalog.not_applicable'),
            },
          }
        }

        return {
          type: 'text' as const,
          value: item.legalEntity?.legalName,
        }
      },
    },
    {
      label: i18n.t('finance.cost_center_people_list.current_assignments'),
      render: (item: FormattedCostCenterEmployeeWithStructuredAssignment) => {
        return {
          type: 'text' as const,
          value: item.currentAssignmentLabel,
        }
      },
    },
    {
      label: i18n.t('finance.cost_centers_list.headers.current_allocation'),
      render: (item: FormattedCostCenterEmployeeWithStructuredAssignment) => {
        return {
          type: 'text' as const,
          value: `${(item.percentage * 100).toFixed(2)}%`,
        }
      },
    },
    {
      label: i18n.t('finance.cost_centers_list.headers.job_catalog.start_date'),
      render: (item: FormattedCostCenterEmployeeWithStructuredAssignment) => {
        return {
          type: 'text' as const,
          value: item.startDate ? moment(item.startDate).format('L') : '',
        }
      },
    },
  ]
}
